Date.prototype.addDays = function (days) {
    let date = new Date(this.valueOf())
    date.setDate(date.getDate() + days)

    return date
}

function createLiElement(date, commission) {
    let li = document.createElement('li')
    li.classList.add('list__item', 'd-flex', 'justify-content-between')
    let div1 = document.createElement('div')
    div1.classList.add('text-muted')
    div1.textContent = `до ${date}`
    let div2 = document.createElement('div')
    div2.classList.add('fw-bold', 'text-end', 'text-muted')
    div2.textContent = commission.toFixed(2)
    let small = document.createElement('small')
    small.textContent = 'грн.'

    div2.insertAdjacentElement('beforeend', small)
    li.insertAdjacentElement('beforeend', div1)
    li.insertAdjacentElement('beforeend', div2)

    return li
}

function updateXIRR() {
    if (!document.querySelector('.js-calculator')) return

    let amount = document.querySelector('.js-amount-input').value

    fetch(document.querySelector('.js-calculator').dataset.urlXirr, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify({
            _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            amount: parseFloat(document.querySelector('.js-amount-input').value),
            period: parseFloat(document.querySelector('.js-period-input')?.value ?? document.querySelector('.js-calculator').dataset.periodDefault),
            lending: parseFloat(document.querySelector('.js-calculator').dataset.periodLending),
            interest: parseFloat(document.querySelector('.js-calculator').dataset.rateDef),
            delay: parseFloat(document.querySelector('.js-calculator').dataset.rateDelay),
            commission: parseFloat(document.querySelector('.js-calculator').dataset.rateCommission),
        }),
    })
        .then((response) => response.json())
        .then((data) => {
            if (data.success === true) {
                document.querySelectorAll('.js-xirr').forEach((item) => (item.textContent = data.percent.toString()))
            } else {
                document.querySelectorAll('.js-xirr').forEach((item) => (item.textContent = ''))
            }
        })
        .catch((error) => {
            console.error(error)
        })
}

function updateSchedule() {
    if (!document.querySelector('.js-calculator')) return

    let amount = parseFloat(document.querySelector('.js-amount-input').value)
    let period = parseInt(document.querySelector('.js-period-input')?.value)
    let rate = parseFloat(document.querySelector('.js-calculator').dataset.rateDef)
    let rateAccrual = parseFloat(document.querySelector('.js-calculator').dataset.rateAccrual)
    let commissionDefault = ((amount * rate) / 100) * period

    let debtContract = 0
    let rateCommission = parseFloat(document.querySelector('.js-calculator').dataset.rateCommission)
    let commission = (amount / 100) * rateCommission
    let accrualAmount = amount / 100 * rateAccrual * period

    fetch(document.querySelector('.js-calculator').dataset.urlSchedule, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify({
            _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            amount: document.querySelector('.js-amount-input').value,
            period: document.querySelector('.js-period-input')?.value,
            lending: document.querySelector('.js-calculator').dataset.periodLending,
            interest: document.querySelector('.js-calculator').dataset.rateDef,
            delay: document.querySelector('.js-calculator').dataset.rateDelay,
            commission: document.querySelector('.js-calculator').dataset.rateCommission,
            accrual: document.querySelector('.js-calculator').dataset.rateAccrual,
        }),
    })
        .then((response) => response.json())
        .then((data) => {
            if (data.success === true) {
                document.querySelector('.js-payment-schedule').innerHTML = ''

                for (let [i, e] of data.schedule.entries()) {
                    if (i === 0) continue

                    let li = createLiElement(e.date, e.sum)
                    document.querySelector('.js-payment-schedule').insertAdjacentElement('beforeend', li)
                    debtContract += e.sum
                }
                document
                    .querySelectorAll('.js-commission-contract')
                    .forEach((item) => (item.textContent = (debtContract + commissionDefault - amount).toFixed(2)))
                document
                    .querySelectorAll('.js-total-costs')
                    .forEach(
                        (item) =>
                            (item.textContent = (debtContract + commissionDefault - amount + commission + accrualAmount).toFixed(2)),
                    )
                document
                    .querySelectorAll('.js-return-contract')
                    .forEach((item) => (item.textContent = (debtContract + commissionDefault + commission + accrualAmount).toFixed(2)))
                document.querySelector('.js-number-payments').textContent = data.schedule.length
                document.querySelectorAll('.js-xirr').forEach((item) => (item.textContent = data.xirr.toString()))
            }
        })
        .catch((error) => {
            console.error(error)
        })
}

function calculate() {
    let amount = parseFloat(document.querySelector('.js-amount-input').value)
    let periodInput = document.querySelector('.js-period-input')?.value;
    let period = parseInt(periodInput) || parseInt(document.querySelector('.js-calculator')?.dataset.periodLending);
    let rateInterest = parseFloat(document.querySelector('.js-calculator').dataset.rateDef)
    let rateAccrual = parseFloat(document.querySelector('.js-calculator').dataset.rateAccrual)
    let rateCommission = parseFloat(document.querySelector('.js-calculator').dataset.rateCommission)

    let lang = document.querySelector('html').getAttribute('lang')
    let trans = new Intl.RelativeTimeFormat(lang, { numeric: 'auto' }).formatToParts(period, 'day')
    let date = new Date()
    let interestAmount = amount / 100 * rateInterest * period
    let commissionAmount = amount / 100 * rateCommission
    let accrualAmount = amount / 100 * rateAccrual * period

    updateBlockedHintDisplay(amount)
    updateTabs(amount)

    document.querySelectorAll('.js-amount-display').forEach((item) => (item.textContent = amount.toString()))
    document
        .querySelectorAll('.js-period-display')
        .forEach((item) => (item.textContent = trans[1]?.value.toString() ?? ''))
    document
        .querySelectorAll('.js-lang-days-display')
        .forEach((item) => (item.textContent = trans[2]?.value.toString() ?? trans[0]?.value.toString()))
    document.querySelectorAll('.js-interest').forEach((item) => (item.textContent = (rateInterest/100 * period * amount).toFixed(2)))
    document.querySelectorAll('.js-interest-schedule').forEach((item) => (item.textContent = (interestAmount + commissionAmount + accrualAmount).toFixed(2)))
    document
        .querySelectorAll('.js-return')
        .forEach((item) => (item.textContent = (amount + interestAmount + commissionAmount).toFixed(2)))
    document
        .querySelectorAll('.js-expiration-date')
        .forEach((item) => (item.textContent = `${date.addDays(period).toLocaleDateString(lang)}`))
    document.querySelectorAll('.js-rate').forEach((item) => (item.textContent = rateInterest.toString()))
    document.querySelectorAll('.js-rate-year').forEach((item) => (item.textContent = (rateInterest * 365).toString()))
    document.querySelectorAll('.js-commission').forEach((item) => (item.textContent = commissionAmount.toFixed(2)))

    let expirationBlock = document.querySelector('.js-expiration-block')
    if(expirationBlock) {
        expirationBlock.classList.remove('alert-success', 'alert-danger')
        switch (date.addDays(period).getDay()) {
            case 0:
                expirationBlock.classList.add('alert-danger')
                document.querySelector('.js-expiration-day').innerText = '(Нд)'
                break
            case 1:
                expirationBlock.classList.add('alert-success')
                document.querySelector('.js-expiration-day').innerText = '(Пн)'
                break
            case 2:
                expirationBlock.classList.add('alert-success')
                document.querySelector('.js-expiration-day').innerText = '(Вт)'
                break
            case 3:
                expirationBlock.classList.add('alert-success')
                document.querySelector('.js-expiration-day').innerText = '(Ср)'
                break
            case 4:
                expirationBlock.classList.add('alert-success')
                document.querySelector('.js-expiration-day').innerText = '(Чт)'
                break
            case 5:
                expirationBlock.classList.add('alert-success')
                document.querySelector('.js-expiration-day').innerText = '(Пт)'
                break
            case 6:
                expirationBlock.classList.add('alert-danger')
                document.querySelector('.js-expiration-day').innerText = '(Сб)'
                break
        }
    }
}

function showAmountRangeBlock() {
    let calculator = document.querySelector('.js-calculator')
    let widthInputAmount = (calculator.dataset.sumClientMax / calculator.dataset.sumMax) * 100
    let amountRangeBlocked = document.querySelector('.js-amount-range-blocked');

    if (widthInputAmount < 100 && amountRangeBlocked) {
        amountRangeBlocked.style.display = 'block'
        document.querySelector('.js-amount-range-separator').style.display = 'block'
    }
}

function updateBlockedHintDisplay(amount) {
    const hintElement = document.querySelector('.js-blocked-hint')
    let calculator = document.querySelector('.js-calculator')

    if (
        calculator.dataset.sumClientMax !== calculator.dataset.sumMax &&
        calculator.dataset.sumClientMax - amount === 0
    ) {
        hintElement.classList.remove('d-none')
        setTimeout(() => hintElement.classList.add('show'), 15)
    } else {
        hintElement.classList.remove('show')
        hintElement.classList.add('d-none')
    }
}

function updateTabs(amount) {
    const firstCredit = document.querySelector('.js-first-credit')
    const secondCredit = document.querySelector('.js-second-credit')

    if (amount > 8000) {
        secondCredit.classList.remove('disabled')
        secondCredit.classList.add('active')
        firstCredit.classList.remove('active')
        firstCredit.classList.add('disabled')
    } else {
        firstCredit.classList.remove('disabled')
        firstCredit.classList.add('active')
        secondCredit.classList.remove('active')
        secondCredit.classList.add('disabled')
    }
}

for (let e of document.querySelectorAll('.form-range')) {
    e.style.setProperty('--value', e.value)
    e.style.setProperty('--min', e.min === '' ? '0' : e.min)
    e.style.setProperty('--max', e.max === '' ? '100' : e.max)
    e.addEventListener('input', () => e.style.setProperty('--value', e.value))
}

if (document.querySelector('.js-code')) {
    document.querySelector('.js-code').onclick = (event) => {
        event.preventDefault()

        let modalPromoCode = bootstrap.Modal.getOrCreateInstance(document.querySelector('#promo-code-modal'))
        let modalInformation = bootstrap.Modal.getOrCreateInstance(document.querySelector('#modal-information'))
        let url = document.querySelector('.js-code').dataset.url

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify({
                _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                product_id: document.querySelector('.js-code').closest('form').querySelector('[name="product_id"]').value,
                type: document.querySelector('.js-code').closest('form').querySelector('[name="type"]').value,
                code: document.querySelector('.js-code').closest('form').querySelector('[name="code"]').value,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success === true) {
                    document.querySelector('.js-calculator').dataset.rateDef = data.rate
                    document.querySelector('.js-calculator [name="promo_code_id"]').value = data.promo_id
                    document.querySelector('#added-promocode').innerText = data.code
                    document.querySelector('#promocode-block').classList.remove('d-none')

                    if(document.querySelector('.js-period-input')) {
                        calculate()
                        updateSchedule()
                    }

                    modalPromoCode.hide()

                    modalInformation._element.querySelector('.js-modal-body').innerHTML = `${data.message}`
                    modalInformation.show()
                } else {
                    document.querySelector('.js-calculator').dataset.rateDef =
                        document.querySelector('.js-calculator').dataset.rateDefault
                    document.querySelector('.js-calculator [name="promo_code_id"]').value = ''
                    document.querySelector('#added-promocode').innerText = ''
                    document.querySelector('#promocode-block').classList.add('d-none')

                    const periodInput = document.querySelector('.js-period-input');
                    if (periodInput) {
                        calculate()
                        updateSchedule()
                    }

                    modalPromoCode.hide()

                    modalInformation._element.querySelector('.js-modal-body').innerHTML = `${data.message}`
                    modalInformation.show()
                }
            })
            .catch((error) => {
                console.error(error)
            })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.js-calculator')) {
        document.querySelector('.js-amount-input').oninput = () => calculate()

        const periodInput = document.querySelector('.js-period-input');
        if (periodInput) {
            periodInput.oninput = () => calculate();
            document.querySelector('.js-amount-input').onchange = () => updateSchedule()
            periodInput.onchange = () => updateSchedule();
        }

        showAmountRangeBlock()
        calculate()
        if (periodInput) {
            updateSchedule()
        }
    }
})
